import React from 'react';

import { getSubAbas } from './subabas';
import BarraSubAbas from '../../../components/BarraSubAbas';
import ContainerConteudo from '../../../components/ContainerConteudo';
import ListUsuers from '../../../components/ListUsers';
const ListaUsuarios: React.FC = () => {
  return (
    <>
      <BarraSubAbas subAbas={getSubAbas()} />
      <ContainerConteudo>
        <ListUsuers />
      </ContainerConteudo>
    </>
  );
};

export default ListaUsuarios;
